import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedItem {
  ItemName: string;
  SlotNumber: number;
  Amount: number;
  Quantity: string;
}

interface ItemState {
  selectedItems: SelectedItem[];
}

const initialState: ItemState = {
  selectedItems: []
};

const purchaseItemSlice = createSlice({
  name: 'purchaseItem',
  initialState,
  reducers: {
    setSelectedItem: (state, action: PayloadAction<SelectedItem>) => {
      const existingItemIndex = state.selectedItems.findIndex(
        (item) =>
          item.ItemName === action.payload.ItemName && item.SlotNumber === action.payload.SlotNumber
      );

      if (existingItemIndex !== -1) {
        state.selectedItems[existingItemIndex].Quantity = action.payload.Quantity;
      } else {
        state.selectedItems.push(action.payload);
      }
    },
    clearSelectedItems: (state) => {
      state.selectedItems = [];
    }
  }
});

export const { setSelectedItem, clearSelectedItems } = purchaseItemSlice.actions;

export default purchaseItemSlice.reducer;
